import React from "react";
import "react-data-table-component-extensions/dist/index.css";
import { StandingPerUserTable } from "../allTables/allTable";
import StandingService from "../../services/standing.service";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";

export function StandingPerUer() {
  const location = useLocation();
  const [data, setData] = useState("");
  const id = location?.state?.id;
  const hashtagAssign = location?.state?.hashtagAssign;
  const threeLatterName = location?.state?.threeLatterName;
  const threeLatterNametotalScore = location?.state?.totalScore;
  const userName = location?.state?.userName;
  const getSingleUser = async () => {
    const response = await StandingService.GetSingleStanding(id);
    setData(response.data.data.playerRaceHistory);
  };
  useEffect(() => {
    getSingleUser();
  }, []);

  return (
    <>
      <div className="page-header2"></div>
      <StandingPerUserTable
        data={data}
        hashtagAssign={hashtagAssign}
        threeLatterName={threeLatterName}
        totalScore={threeLatterNametotalScore}
        userName={userName}
      />
    </>
  );
}
